/**
 * Spacing / alignment guide palette — tuned for contrast on dark canvases.
 * Gold edge lines · purple horizontal equal · blue vertical equal · orange rhythm · slate measure.
 */
export const GUIDE_COLOR_ALIGNMENT = 'rgba(202, 138, 4, 0.95)'; // amber-600 / gold — edge alignment lines

export const GUIDE_COLOR_MEASURE = 'rgba(100, 116, 139, 0.95)'; // slate-500

export const GUIDE_COLOR_HORIZONTAL_EQUAL = 'rgba(168, 85, 247, 0.95)'; // violet-500 — horizontal equal gaps

export const GUIDE_COLOR_VERTICAL_EQUAL = 'rgba(37, 99, 235, 0.92)'; // blue-600

export const GUIDE_COLOR_RHYTHM_MATCH = 'rgba(234, 88, 12, 0.92)'; // orange-600

export const GUIDE_COLOR_OVERLAP = 'rgba(15, 23, 42, 0.95)'; // slate-900

export const SPACING_GUIDE_LEGEND = [
  { key: 'measure', label: 'Measure', swatch: GUIDE_COLOR_MEASURE, shape: 'pill' as const },
  { key: 'rhythm', label: 'Matches layout gap (selected)', swatch: GUIDE_COLOR_RHYTHM_MATCH, shape: 'rounded' as const },
  { key: 'equal-h', label: 'Equal beside selection', swatch: GUIDE_COLOR_HORIZONTAL_EQUAL, shape: 'pill' as const },
  { key: 'equal-v', label: 'Equal top/bottom', swatch: GUIDE_COLOR_VERTICAL_EQUAL, shape: 'pill' as const },
  { key: 'overlap', label: 'Overlap', swatch: GUIDE_COLOR_OVERLAP, shape: 'pill' as const },
];
